import { SerializableObject } from '../../common-react/core';

/**
 * A partial address used for city postal codes.
 *
 * @see Address
 * @see mobiz-posturinn-extension:Posturinn.Extension.Controllers.PostController.GetPostalCodes
 * @see mobiz-posturinn-extension:Posturinn.Extension.Service.Postal.Services.SystemPostalService.GetPostalCodes
 * @see mobiz-posturinn-extension:Posturinn.Extension.Service.Postal.Mappers.IndexToDTOMapper.Map
 * @see mobiz-posturinn-extension:Posturinn.Extension.Models.Index.Code
 */
export class CityPostalCode extends SerializableObject {
  public city: string;
  public postalCode: string;
}
